module.exports = __webpack_public_path__ + "static/media/facebook.665dd80e.svg";